/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChecklistOperatorModel { 
    operatorId?: number;
    operatorName?: string;
    analyzedCalls?: number;
    greetingPercent?: number;
    politePercent?: number;
    scriptAdherencePercent?: number;
    farewellPercent?: number;
    offeredUpsellPercent?: number;
    infoCorrectPercent?: number;
}

